// Hook TanStack Query — le canal de l avis de l usager connecte (page « Mes parametres »).
// GET /api/parametres/canal-de-l-avis rend le choix courant ; PUT enregistre un accord au texto
// ou son retrait (une ligne de plus au journal ntf.NoticeChannelChanges, mig 271). Aucune regle
// ici : le serveur decide (version du texte, choix inchange, table absente).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@gs/api-client';

export type CanalDeLAvisCode = 'email' | 'sms';

export interface ReglageDuCanal {
  canal: CanalDeLAvisCode;
  /** `defaut` = aucune ligne au journal (le courriel, sans accord) ; `choix` = la derniere ligne. */
  source: 'defaut' | 'choix';
  /** Date d effet du choix (ISO), null au defaut. */
  depuis: string | null;
  /** Version du texte accepte, seulement pour le texto. */
  versionDuTexte: string | null;
  /** La version du texte que le serveur exige pour un accord au texto. */
  versionCouranteDuTexte: string;
}

export type ChoixDuCanal = { canal: 'email' } | { canal: 'sms'; versionDuTexte: string };

const CLE = ['hub', 'parametres', 'canal-de-l-avis'] as const;
const CHEMIN = '/api/parametres/canal-de-l-avis';

export function useCanalDeLAvis(enabled: boolean) {
  return useQuery({
    queryKey: CLE,
    queryFn: () => api.get<ReglageDuCanal>(CHEMIN),
    enabled,
  });
}

export function useChoisirLeCanal() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (choix: ChoixDuCanal) => api.put<ReglageDuCanal>(CHEMIN, choix),
    onSuccess: (reglage) => {
      client.setQueryData(CLE, reglage);
    },
    // Un 409 (texte perime) se relit : la page montre alors la version courante.
    onError: () => {
      void client.invalidateQueries({ queryKey: CLE });
    },
  });
}
